import { useState } from "react";
import { Button, Modal } from "components";
import { FiClock } from "react-icons/fi";
import { MdEmail, MdLocationOn, MdPhone } from "react-icons/md";
import { useIntl } from "react-intl";

import { BranchesInfoContentItem } from "../BranchesInfoContentItem";
import "./BranchesInfoAccordionContent.scss";
import { BranchesInfoMap } from "../BranchesInfoMap";
import { BranchesInfoPinContent } from "../BranchesInfoPinContent";

interface BranchesInfoAccordionContentProps {
  address: string;
  phone: string;
  email: string;
  workingHours: string;
  coords: { lat: number; lng: number };
  title: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
}

export function BranchesInfoAccordionContent({
  address,
  phone,
  email,
  workingHours,
  coords,
  title,
  onClick,
  onMouseEnter
}: BranchesInfoAccordionContentProps) {
  const [showModal, setShowModal] = useState<boolean>(false);

  const { formatMessage } = useIntl();
  
  return (
    <div
      className="branches-info-accordion-content"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
    >
      <BranchesInfoContentItem
        icon={<MdLocationOn />}
        field={formatMessage({
          id: "branches.address",
          defaultMessage: "_branches.address_"
        })}
        text={address}
      />
      {phone && (
        <BranchesInfoContentItem
          icon={<MdPhone />}
          field={formatMessage({
            id: "branches.phone",
            defaultMessage: "_branches.phone_"
          })}
          text={phone}
        />
      )}
      {email && (
        <BranchesInfoContentItem
          icon={<MdEmail />}
          field={formatMessage({
            id: "branches.mail",
            defaultMessage: "_branches.mail_"
          })}
          text={email}
        />
      )}
      {workingHours && (
        <BranchesInfoContentItem
          icon={<FiClock />}
          field={formatMessage({
            id: "branches.working-hours",
            defaultMessage: "_branches.working-hours_"
          })}
          text={workingHours}
        />
      )}
      <Button
        onClick={() => setShowModal(true)}
        className="branches-info-accordion-content__see-on-map-button"
      >
        {formatMessage({
          id: "branches.see-on-map",
          defaultMessage: "_see-on-map_"
        })}
      </Button>

      <Modal
        className="branches-info-modal"
        show={showModal}
        onClose={() => setShowModal(false)}
      >
        <BranchesInfoMap
          customCenter={coords}
          position={coords}
          content={
            <BranchesInfoPinContent
              addressLabel={formatMessage({
                id: "branches.map.pin.address"
              })}
              phoneLabel={formatMessage({
                id: "branches.map.pin.phone"
              })}
              mailLabel={formatMessage({
                id: "branches.map.pin.email"
              })}
              title={title}
              email={email}
              phone={phone}
              address={address}
            />
          }
        />
      </Modal>
    </div>
  );
}
